import { Star } from "lucide-react";
import { SentimentBadge } from "@/shared/components/SentimentBadge";
import type { Mention } from "@/shared/types/mention";

export const APPROACH_STARS: Record<string, number> = { Protagonista: 3, Coadjuvante: 2, Citação: 1 };

export function ApproachStars({ approach, stars, size = 14 }: { approach: string; stars: number; size?: number }) {
  return (
    <div
      className="classification-approach mention-data-tooltip"
      data-tooltip={`Abordagem: ${approach === "Não classificada" ? "não classificada" : approach}`}
      data-tooltip-position="bottom"
      aria-label={`Abordagem: ${approach}`}
    >
      <div className="approach-stars-icons">
        {[1, 2, 3].map(position => (
          <Star key={position} size={size} aria-hidden="true" className={position <= stars ? "filled" : ""}/>
        ))}
      </div>
    </div>
  );
}

// `FormatTag` (Proativa/Reativa) saiu daqui em 2026-08-03: o conceito
// "formato" não existe em nenhum lugar da esteira (`core/`/`elt/`/`ai/`)
// — nada produzia o valor, a tag exibia um dado que nunca viria. Se o
// domínio um dia ganhar o conceito, ele volta com produtor definido.

/** Sentimento primeiro (sinal de leitura primário), abordagem como secundário. */
export function MentionClassification({ mention, stars, starSize = 14 }: { mention: Mention; stars: number; starSize?: number }) {
  return (
    <>
      <div className="classification-sentiment"><SentimentBadge value={mention.sentiment} polarity={mention.polarity} variant="badge"/></div>
      <div className="classification-secondary">
        <ApproachStars approach={mention.approach} stars={stars} size={starSize}/>
      </div>
    </>
  );
}
